import loadable from '@loadable/component';

export const UserDashboardSelectOrgPageLoadable = loadable(
  () => import('./UserDashboardSelectOrgPage'),
  { resolveComponent: (module) => module.UserDashboardSelectOrgPage },
);
